export default "__VITE_ASSET__DFDJs73f__"